import { render, staticRenderFns } from "./KnowledgeCheck.vue?vue&type=template&id=28943135"
import script from "./KnowledgeCheck.vue?vue&type=script&lang=js"
export * from "./KnowledgeCheck.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeCheck.vue?vue&type=style&index=0&id=28943135&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports